import { LinearProgress as LinearProgressUI } from "@evergis/ui";
import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 1.25rem;
`;

export const Description = styled.div`
  font: ${({ theme: { fonts } }) => fonts.description};
  color: ${({ theme: { palette } }) => palette.textSecondary};
  margin-bottom: 1.25rem;
`;

export const LoadingDescription = styled.div`
  color: ${({ theme: { palette } }) => palette.textSecondary};
  margin: 1.5rem 0 0.25rem;
`;

export const LinearProgress = styled(LinearProgressUI)`
  margin-top: 0.875rem;
`;
